import { defineMessages } from 'react-intl.macro';

const messages = defineMessages({
    classOverviewHeader: {
        id: 'classOverview.classOverviewHeader',
        defaultMessage: 'Overview',
    },
    deliveryTypeLabel: {
        id: 'classOverview.deliveryTypeLabel',
        defaultMessage: 'Delivery type',
    },
    virtualDelivery: {
        id: 'classOverview.virtualDelivery',
        defaultMessage: 'Virtual',
    },
    inPersonDelivery: {
        id: 'classOverview.inPersonDelivery',
        defaultMessage: 'In-person',
    },
    locationLabel: {
        id: 'classOverview.locationLabel',
        defaultMessage: 'Location/URL',
    },
    customerLabel: {
        id: 'classOverview.customerLabel',
        defaultMessage: 'Customer',
    },
    learningActivityStatusLabel: {
        id: 'classOverview.learningActivityStatusLabel',
        defaultMessage: 'Learning Activity status',
    },
    semiPrivateCustomer: {
        id: 'classOverview.semiPrivateCustomer',
        defaultMessage: 'Semi-private',
    },
});

export default messages;
